export default "__VITE_ASSET__BqKjf2JV__"